import endpoints from "static/endpoints";
import api from "app/lib/api";

export const hospitalList = async () => {
  const { data } = await api.get(endpoints.hospitals.list);
  return data;
};
